module.exports = __webpack_public_path__ + "static/media/appgarcom.40389034.png";